<template>
  <div
    v-if="report.loaded"
  >
    <q-card
      square
      flat
      bordered
    >
      <q-card-section
        class="row items-center q-gutter-sm"
      >
        <div class="text-h6">
          {{ reportOptions.has_custom_title ? reportOptions.custom_title : reportElement.chart.title }}
        </div>
        <div
          v-if="!reportOptions.has_custom_title"
          class="text-subtitle2 text-grey-8"
        >
          {{ reportElement.chart.subtitle }}
        </div>
        <q-space />
        <report-migratable-button
          v-if="!printing && !editing && reportElement.migratable"
          :class="{ 'data-freshness': reportElement.reportStatus && reportElement.reportStatus.done }"
          @edit="$emit('edit', true)"
        />
        <report-status
          :report-status="reportElement.reportStatus"
          :class="{ 'data-freshness': reportElement.reportStatus && reportElement.reportStatus.done }"
          class="q-mr-sm"
        />
        <q-btn
          v-if="!printing"
          class="download-link"
          icon="download"
          dense
          round
          @click.stop="exportData(reportElement)"
        />
      </q-card-section>

      <q-card-section>
        <aggregate-chart
          v-if="reportElement.chart.chartType === REPORT_CHART_TYPES.AGGREGATE"
          :key="`aggregate-${reportElement.id}`"
          :chart="reportElement.chart"
          :report-element="reportElement"
          :report-options="reportOptions"
          @show-source="point => $emit('show-source', point)"
        />
        <bubble-chart
          v-else-if="reportElement.chart.chartType === REPORT_CHART_TYPES.BUBBLE"
          :key="`bubble-${reportElement.id}`"
          :chart="reportElement.chart"
          :report-element="reportElement"
          :report-options="reportOptions"
        />
        <time-series-chart
          v-else-if="reportElement.chart.chartType === REPORT_CHART_TYPES.TIME_SERIES"
          :key="`time-${reportElement.id}`"
          :chart="reportElement.chart"
          :report-element="reportElement"
          :report-options="reportOptions"
          @show-source="point => $emit('show-source', point)"
        />
        <highcharts
          v-else
          :key="reportElement.id + ':' + chartKey"
          ref="chart"
          :options="reportElement.chart.chartData"
          class="full-width"
        />
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import { REPORT_CHART_TYPES } from 'src/models/report/ReportChart'
import ReportMigratableButton from 'src/modules/admin/report/ReportMigratableButton'
import ReportStatus from 'src/modules/admin/report/ReportStatus'
import AggregateChart from 'src/modules/admin/report-chart/AggregateChart'
import BubbleChart from 'src/modules/admin/report-chart/BubbleChart'
import TimeSeriesChart from 'src/modules/admin/report-chart/TimeSeriesChart'

export default {
  name: 'ReportChart',
  components: {
    ReportStatus,
    ReportMigratableButton,
    AggregateChart,
    BubbleChart,
    TimeSeriesChart
  },
  props: {
    chart: {
      type: Object,
      required: true
    },
    report: {
      type: Object,
      required: true
    },
    reportElement: {
      type: Object,
      required: true
    },
    reportOptions: {
      type: Object,
      required: true
    },
    reportStatus: {
      type: Object,
      required: false,
      default: null
    },
    showFilter: {
      type: Boolean,
      required: false,
      default: undefined
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    printing: {
      type: Boolean,
      required: false,
      default: false
    },
    editing: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['show-source', 'edit'],
  data () {
    return {
      loading: false,
      chartKey: 0,
      showEditFilter: false,
      showColumnSelector: false,
      showGroupingSelector: false,
      editFilterField: null,
      showReportFilters: false
    }
  },
  computed: {
  },
  watch: {
    'element.chart.chartData.xAxis.type': {
      handler () {
        this.chartKey += 1
      }
    }
  },
  created () {
    _.extend(this, { REPORT_CHART_TYPES })
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
